// import axios from 'axios';
import { ajaxGet } from 'lib/ajax-helpers';

export function forceDownload(blob, filename) {
  const a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Current blob size limit is around 500MB for browsers
export function downloadResource({
  url, filename, downloadSize = 'original', reloadPage = false,
}) {
  const makeFilename = () => {
    let fn;

    if (!filename) fn = url.split('\\').pop().split('/').pop();

    fn = downloadSize !== 'original' ? `${downloadSize}-${fn}` : fn;

    return fn;
  };

  const reloadAfterDl = () => {
    window.setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  if (downloadSize === 'original') {
    // if we're reloading the page after the download, we need to
    // open the file download url in a new "tab" for some reason.
    if (reloadPage) {
      window.open(url, '_blank');

      reloadAfterDl();
    } else {
      window.location.href = url;
    }
  } else {
    ajaxGet(url,
      (response) => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type });
        const blobUrl = window.URL.createObjectURL(blob);

        forceDownload(blobUrl, makeFilename());

        if (reloadPage) reloadAfterDl();
      },
      (error) => console.error(error), {},
      {
        headers: {},
        mode: 'cors',
        responseType: 'blob',
      });
  }
}
